// src/constants/actionTypes.js

const BASE_URL =
  import.meta.env.VITE_API_URL || "https://dev.qms.local:8080/api";

export const API_ENDPOINTS = {
  // Auth Group
  LOGIN: `${BASE_URL}/auth/login`,
  LOGOUT: `${BASE_URL}/auth/logout`,
  FORGOT_PASSWORD: `${BASE_URL}/auth/ForgotPassword`,
  CHANGE_PASSWORD: `${BASE_URL}/auth/ChangePassword`,
  VERIFY_OTP: `${BASE_URL}/Auth/VerifyOtp`,
  RESET_PASSWORD: `${BASE_URL}/Auth/ResetPassword`,
  CHECK_AUTH: `${BASE_URL}/auth/check-session`,
  REFRESH_TOKEN: `${BASE_URL}/auth/refresh`,

  // Branch Group
  BRANCH: {
    SELECT_ALL: `${BASE_URL}/Branch/SelectAll`,
    SELECT: `${BASE_URL}/Branch/Select`,
    INSERT: `${BASE_URL}/Branch/Insert`,
    UPDATE: `${BASE_URL}/Branch/Update`,
    DELETE: `${BASE_URL}/Branch/Delete`,
    DROPDOWN: `${BASE_URL}/Branch/DropDown`,
  },

  // BranchSetting Group
  BRANCH_SETTING: {
    SELECT_ALL: `${BASE_URL}/BranchSetting/SelectAll`,
    SELECT: `${BASE_URL}/BranchSetting/Select`,
    INSERT: `${BASE_URL}/BranchSetting/Insert`,
    UPDATE: `${BASE_URL}/BranchSetting/Update`,
    GENERATE_QR: `${BASE_URL}/BranchSetting/GenerateQR`,
    DOWNLOAD_QR: `${BASE_URL}/BranchSetting/DownloadQR`,
    DOWNLOAD_ALL_QR: `${BASE_URL}/BranchSetting/DownloadAllQR`,
  },

  // Company Group
  COMPANY: {
    SELECT_ALL: `${BASE_URL}/Company/SelectAll`,
    SELECT: `${BASE_URL}/Company/Select`,
    INSERT: `${BASE_URL}/Company/Insert`,
    UPDATE: `${BASE_URL}/Company/Update`,
    DELETE: `${BASE_URL}/Company/Delete`,
    DROPDOWN: `${BASE_URL}/Company/DropDown`,
  },

  // CompanyUser Group
  COMPANY_USER: {
    INSERT: `${BASE_URL}/CompanyUser/Insert`,
    UPDATE: `${BASE_URL}/CompanyUser/Update`,
    SELECT_BY_ID: `${BASE_URL}/CompanyUser/Select`,
    SELECT_ALL: `${BASE_URL}/CompanyUser/SelectAll`,
    DELETE: `${BASE_URL}/CompanyUser/Delete`,
  },

  // PlatformUser Group
  PLATFORM_USER: {
    INSERT: `${BASE_URL}/PlatformUser/Insert`,
    UPDATE: `${BASE_URL}/PlatformUser/Update`,
    SELECT_BY_ID: `${BASE_URL}/PlatformUser/SelectById`,
    SELECT_ALL: `${BASE_URL}/PlatformUser/SelectAll`,
    DELETE: `${BASE_URL}/PlatformUser/Delete`,
  },

  // Role Group
  ROLE: {
    SELECT_ALL: `${BASE_URL}/Role/SelectAll`,
    SELECT: `${BASE_URL}/Role/Select`,
    INSERT: `${BASE_URL}/Role/Insert`,
    UPDATE: `${BASE_URL}/Role/Update`,
    DELETE: `${BASE_URL}/Role/Delete`,
  },

  // RolePermission Group
  ROLE_PERMISSION: {
    SELECT_ALL: `${BASE_URL}/RolePermission/SelectAll`,
    SELECT: `${BASE_URL}/RolePermission/Select`,
    INSERT: `${BASE_URL}/RolePermission/Insert`,
    UPDATE: `${BASE_URL}/RolePermission/Update`,
    DELETE: `${BASE_URL}/RolePermission/Delete`,
    SAVE: `${BASE_URL}/RolePermission/Save`,
  },

  // SubscriptionPlan Group
  SUBSCRIPTION_PLAN: {
    SELECT_ALL: `${BASE_URL}/SubscriptionPlan/SelectAll`,
    SELECT: `${BASE_URL}/SubscriptionPlan/Select`,
    INSERT: `${BASE_URL}/SubscriptionPlan/Insert`,
    UPDATE: `${BASE_URL}/SubscriptionPlan/Update`,
    DELETE: `${BASE_URL}/SubscriptionPlan/Delete`,
  },

  // Module Group
  MODULE: {
    SELECT_ALL: `${BASE_URL}/Module/SelectAll`,
    SELECT: `${BASE_URL}/Module/Select`,
    INSERT: `${BASE_URL}/Module/Insert`,
    UPDATE: `${BASE_URL}/Module/Update`,
    DELETE: `${BASE_URL}/Module/Delete`,
  },

  // Customer Group
  CUSTOMER: {
    SELECT_ALL: `${BASE_URL}/Customer/SelectAll`,
    SELECT: `${BASE_URL}/Customer/Select`,
    REGISTER: `${BASE_URL}/Customer/Register`,
    SELF_REGISTER: `${BASE_URL}/Customer/SelfRegister`,
    PENDING: `${BASE_URL}/Customer/Pending`,
    APPROVE: `${BASE_URL}/Customer/Approve`,
    REJECT: `${BASE_URL}/Customer/Reject`,
    SUBMIT: `${BASE_URL}/Customer/Submit`,
    FEEDBACK: `${BASE_URL}/Customer/Feedback`,
    FEEDBACK_SELECT_ALL: `${BASE_URL}/Customer/FeedbackSelectAll`,
  },

  // Service Group
  SERVICE: {
    INSERT: `${BASE_URL}/Service/Insert`,
    UPDATE: `${BASE_URL}/Service/Update`,
    SELECT: `${BASE_URL}/Service/Select`,
    SELECT_ALL: `${BASE_URL}/Service/SelectAll`,
    DELETE: `${BASE_URL}/Service/Delete`,
    DROPDOWN: `${BASE_URL}/Service/DropDown`,
  },

  // Track Group
  TRACK: {
    GET_STATUS: `${BASE_URL}/Track`,
  },

  // UserActionLog Group
  USER_ACTION_LOG: {
    SELECT_ALL: `${BASE_URL}/UserActionLog/SelectAll`,
    SELECT: `${BASE_URL}/UserActionLog/Select`,
  },

  // Report Group
  REPORT: {
    STAFF_PERFORMANCE: `${BASE_URL}/Report/StaffPerformance`,
    ANALYTICS: `${BASE_URL}/Report/Analytics`,
    STAFF_RATINGS: `${BASE_URL}/Report/StaffRatings`,
    CUSTOMER_SUMMARY: `${BASE_URL}/Report/CustomerSummary`,
    SERVICE_USAGE: `${BASE_URL}/Report/ServiceUsage`,
    EMPLOYEE_SERVICE: `${BASE_URL}/Report/EmployeeService`,
  },

  // QueueToken Group
  QUEUE_TOKEN: {
    SELECT_ALL: `${BASE_URL}/QueueToken/SelectAll`,
    SELECT: `${BASE_URL}/QueueToken/Select`,
    CALL: `${BASE_URL}/QueueToken/Call`,
    COMPLETE: `${BASE_URL}/QueueToken/Complete`,
    SKIP: `${BASE_URL}/QueueToken/Skip`,
    LIVE: `${BASE_URL}/QueueToken/Live`,
    TRACK: `${BASE_URL}/QueueToken/Track`,
  },
};
